// Accent-insensitive text search. Mexican Spanish is full of diacritics
// (Bajío, Ángeles, empeño), but people type without them ("bajio"). Folding
// both the haystack and the query to a diacritic-free lowercase form lets
// "bajio" match "Bajío" and "angeles" match "Ángeles".

/** Lowercase + strip combining diacritics (NFD decomposition). */
export function foldForSearch(value: string): string {
  return value
    .normalize('NFD')
    .replace(/\p{Diacritic}/gu, '')
    .toLowerCase()
}

/**
 * True when `query` is found in `haystack`, ignoring case and accents. An empty
 * (or whitespace-only) query matches everything.
 */
export function matchesSearch(haystack: string, query: string): boolean {
  const q = foldForSearch(query.trim())
  if (q === '') return true
  return foldForSearch(haystack).includes(q)
}
